<ng-container *ngIf="_ticketData">
  <p>[이메일 미리 보기]</p>
  <div class="ticket">
    <div class="ticket-header">
      <img
        *ngIf="_ticketData.sender_logo_image_url"
        class="logo"
        src="{{ _ticketData.sender_logo_image_url }}"
      />
    </div>
    <div class="ticket-body">
      <p>
        <ng-container *ngIf="_ticketData.language === 'ko'">
          <span [class.active]="focusedInput === 'sender'">{{
            _ticketData.sender_name
          }}</span
          >님이 &#60;{{ contents?.title }}&#62;을/를 무료로 열람할 수 있는
          북티켓을 선물하셨습니다. <br />
          지금 바로 북티켓을 사용해 전자책을 열람하세요.
        </ng-container>
        <ng-container *ngIf="_ticketData.language === 'en'">
          <span [class.active]="focusedInput === 'sender'">{{
            _ticketData.sender_name
          }}</span
          >send you a free Book Ticket to read &#60;{{ contents?.title }}&#62;.
        </ng-container>
      </p>
      <p class="text-secondary text-small">
        &#8226;
        <ng-container *ngIf="_ticketData.language === 'ko'"
          >북티켓 서비스는 북이오 플랫폼을 사용합니다. 전자책 열람을 위해서는
          북이오 계정이 필요합니다.</ng-container
        >
        <ng-container *ngIf="_ticketData.language === 'en'"
          >Use the Book Ticket now to read your e-book. Book Ticket service is
          powered by bukio. You need a bukio account to read this
          e-book.</ng-container
        >
      </p>

      <div class="ticket-contents">
        <div class="contents" *ngIf="contentsType === 'book'">
          <div class="contents-info">
            <div>
              <div
                class="image-wrapper"
                [class.placeholder]="!contents?.thumbnail"
              >
                <img
                  class="thumbnail"
                  *ngIf="contents?.thumbnail"
                  src="{{ contents.thumbnail }}"
                />

                <mat-icon
                  *ngIf="!contents?.thumbnail"
                  class="thumbnail-placeholder-icon"
                  >help</mat-icon
                >
              </div>
              <img
                class="ticket-icon"
                src="assets/images/book-ticket-icon.svg"
              />
            </div>

            <p class="title" *ngIf="contents?.title; else titlePlaceholder">
              <strong>{{ contents.title }}</strong>
            </p>
            <ng-template #titlePlaceholder>
              <p class="title text-secondary">
                {{
                  _ticketData.language === 'ko'
                    ? '도서를 선택하세요'
                    : 'Select a book'
                }}
              </p>
            </ng-template>
            <p class="author" *ngIf="contents?.author">{{ contents.author }}</p>
          </div>
        </div>

        <div class="contents service" *ngIf="contentsType === 'service'">
          <div class="contents-info">
            <img class="thumbnail" src="{{ contents.thumbnail }}" />
            <strong>{{ contents.title }}</strong>
          </div>
          <img class="ticket-icon" src="assets/images/book-ticket-icon.svg" />
        </div>
      </div>

      <app-hr class="hr"></app-hr>

      <p>
        <ng-container *ngIf="_ticketData.language === 'ko'">
          <span [class.active]="focusedInput === 'sender'">{{
            _ticketData.sender_name
          }}</span
          >님이 보낸 메시지
        </ng-container>
        <ng-container *ngIf="_ticketData.language === 'en'"
          >Message From
          <span [class.active]="focusedInput === 'sender'">{{
            _ticketData.sender_name
          }}</span></ng-container
        >
      </p>
      <pre
        class="message-box"
      ><span [class.active]="focusedInput === 'message'">{{ _ticketData.message }}</span></pre>

      <ul class="noti" *ngIf="!isUnlimitedTicket">
        <ng-container *ngIf="_ticketData.language === 'ko'">
          <li *ngIf="expiryDate">
            북티켓은
            <b [class.active]="focusedInput === 'expiryDate'">{{
              expiryDate | date: 'yyyy년 MM월 dd일'
            }}</b>
            까지 수령할 수 있습니다.
          </li>
          <li>
            북티켓으로 선물 받은 도서는 티켓
            <b
              >수령 후

              <span [class.active]="focusedInput === 'period'">{{
                _ticketData.period | periodTranslate
              }}</span>

              간 열람</b
            >할 수 있습니다.
          </li>
        </ng-container>
        <ng-container *ngIf="_ticketData.language === 'en'">
          <li *ngIf="expiryDate">
            This ticket will be expired on
            <b [class.active]="focusedInput === 'expiryDate'">{{
              expiryDate | date: 'dd/MM/yy'
            }}</b>
          </li>
          <li>
            You can read the e-book for
            <b>
              <span [class.active]="focusedInput === 'period'">{{
                _ticketData.period | periodTranslate: { language: 'en' }
              }}</span>
            </b>
            since you activate the book ticket.
          </li>
        </ng-container>
      </ul>

      <div>
        <button>
          <ng-container *ngIf="_ticketData.language === 'ko'"
            >북티켓 받기</ng-container
          >
          <ng-container *ngIf="_ticketData.language === 'en'"
            >Receive the ticket</ng-container
          >
        </button>
      </div>
      <p class="text-small">
        <ng-container *ngIf="_ticketData.language === 'ko'"
          >북티켓 수령을 위해서는 북이오 로그인이 필요합니다.</ng-container
        >
        <ng-container *ngIf="_ticketData.language === 'en'"
          >To receive and activate the ticket, You need to sign in
          bukio.</ng-container
        >
      </p>
    </div>
  </div>
</ng-container>
